import { Body2 } from "@coherehealth/common";
import { SvgIconComponent } from "@mui/icons-material";
import { Box } from "@mui/material";
import { NavLink, NavLinkProps } from "react-router-dom";
import { useQmNavigationStyles } from "./qmNavigationStyles";

interface NavItemProps extends NavLinkProps {
  testid?: string;
  label: string;
  Icon: SvgIconComponent;
}
export const NavItem = ({ testid, label, to, Icon }: NavItemProps) => {
  const classes = useQmNavigationStyles({});
  return (
    <NavLink data-testid={testid} to={to} style={{ textDecoration: "none", color: "inherit" }}>
      {({ isActive }) => (
        <Box display="flex" justifyContent={"flex-start"}>
          <Box className={classes.navLinkTab} visibility={isActive ? "visible" : "hidden"} />
          <Box color={isActive ? "text.secondary" : "text.disabled"} className={classes.icon}>
            {Icon && (
              <Box>
                <Icon />
              </Box>
            )}
            <Body2 style={{ alignContent: "center" }}>{label}</Body2>
          </Box>
        </Box>
      )}
    </NavLink>
  );
};
